import { PapiroConsole } from '../utils/papiroConsole';
import Api from './api';

export const GetAllConfigStatus = async () => { 
  let data = [];
  await Api.get(`/configcalledsstatusliststatuslist/get-all-config-status`)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

